import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
  colors: {
    black: '#2C2A29',
    gray: {
      '900': '#2C2A29',
      '800': '#53565A',
      '700': '#78797A',
      '600': '#8A909C',
      '500': '#A7A8AA',
      '300': '#E5E5E6',
      '100': '#FAFAFA',
    },
    b: {
      // '800': '#2C2A29',
      // '700': '#2C2A29',
      // '600': '#2C2A29',
      '500': '#2C2A29',
      // '300': '#2C2A29',
      // '100': '#2C2A29',
    },
    blue: '#71C5E8',
    green: {
      '900': '#49C5B1',
    },
    yellow: '#FFC56E',
    orange: {
      '100': '#FEEBC8',
      '200': '#FDAA63',
      '300': '#F6AD55',
      '800': '#7B341E',
    },
    pink: '#FF8DA1',

    // red: '#F66451',
  },
  fonts: {
    heading: 'Roboto',
    body: 'Roboto',
  },
  styles: {
    global: {
      body: {
        bg: 'white',
      },
      'h1, h2, h3, h4, h5': {
        color: 'gray.900',
      },
    },
  },
});
